import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { EmployeeRequest, EmployeeResponse } from '@/types/employee';

export const employeesApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<EmployeeResponse>>>('/v1/employees', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<EmployeeResponse>>(`/v1/employees/${id}`)),

  create: (body: EmployeeRequest) =>
    unwrap(api.post<ApiResponse<EmployeeResponse>>('/v1/employees', body)),

  update: (id: number, body: EmployeeRequest) =>
    unwrap(api.put<ApiResponse<EmployeeResponse>>(`/v1/employees/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/employees/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<EmployeeResponse>>(`/v1/employees/${id}/activate`, null, {
        params: { active },
      }),
    ),
};
